import { z } from 'zod'
import { MODE } from '../../../data/queryFactories'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Modal } from '../../../components/ui'
import { useEffect } from 'react'
import FormPageHeader from '../FormPageHeader'
import { courseOptions } from '../../../data/account_constants'
import FormField from '../../../components/function/form/FormField'
import { toTitleCase } from '../../../utils/conversion'
import useGetAccountGroup from './hooks/useGetAccountGroup'
import { showErrorToast } from '../../../utils/showToast'
export const accountSchema = z.object({
  schoolId: z
    .string()
    .min(1, { message: 'Vui lòng nhập mã định danh' }),
  // .regex(/^\d{8}$/, { message: 'Mã tài khoản bao gồm 8 chữ số' }),
  fullName: z
    .string()
    .regex(/^[\p{L}\s]+$/u, { message: 'Tên chỉ bao gồm các ký tự chữ cái' }),
  studentCourse: z.string().min(1, { message: 'Vui lòng chọn khoá' }),
  groupUuids: z
    .array(z.string())
    .min(1, { message: 'Tài khoản phải thuộc ít nhất một nhóm.' }),
  schoolEmail: z.string().email({ message: '"Email không hợp lệ.' }), //TO- DO: Chi tiết hơn với validate email trường và số ký tự để dảm bảo
  // personalEmail: z
  //   .string()
  //   .optional()
  //   .refine((val) => !val || /\S+@\S+\.\S+/.test(val), {
  //     message: 'Email cá nhân không hợp lệ.',
  //   }),
  // email: z.string().email({ message: 'Vui lòng nhập đúng định dạng email' }),
  // phoneNumber: z
  //   .string()
  //   // .regex(/^0\d{9}$/, { message: })
  //   .optional()
  //   .refine((val) => !val || /^0\d{9}$/.test(val), {
  //     message: 'Số điện thoại không hợp lệ.',
  //   }),
  // className: z.string().min(1, { message: 'Vui lòng chọn lớp' }),
  // faculty: z
  //   .string()
  //   .min(1, { message: 'FVui lòng chọn lớp để xác nhận viện' }),
  // school: z
  //   .string()
  //   .min(1, { message: 'Vui lòng chọn lớp để xác nhận trường' }),
})

export default function AccountForm({
  mode,
  initForm,
  submitHandler,
  closePopUp,
}) {
  const {
    watch,
    register,
    control,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isSubmitted },
  } = useForm({
    resolver: zodResolver(accountSchema),
    defaultValues: initForm,
  })
  const [schoolId, fullName] = watch(['schoolId', 'fullName'])
  useEffect(() => {
    if (schoolId) {
      setValue('schoolEmail', `${schoolId}@st.neu.edu.vn`)
      if (schoolId.length === 8) {
        clearErrors('schoolEmail')
      }
    }
    if (fullName) {
      setValue('fullName', toTitleCase(fullName))
    }
  }, [fullName, schoolId, setValue, clearErrors])
  useEffect(() => {}, [errors])
  useEffect(() => {
    if (isSubmitted && Object.keys(errors).length > 0) {
      showErrorToast({
        error: 'Vui lòng điền đầy đủ thông tin bắt buộc',
      })
    }
  }, [errors, isSubmitted])
  const onSubmit = (formData) => {
    submitHandler(formData)
  }
  const getAccountInfo = () => {
    switch (mode) {
      case MODE.CREATE:
        return {
          title: `Tạo tài khoản`,
          // url: PATH.ACCOUNT.LIST,
          actionName: 'Tạo',
        }
      case MODE.EDIT:
        return {
          title: `Chỉnh sửa tài khoản ${initForm.schoolId}`,
          // url: PATH.ACCOUNT.DETAIL(uuid),
          actionName: 'Cập nhật',
        }
      default:
        return { title: '', url: '', actionName: '' }
    }
  }
  const { title, actionName } = getAccountInfo()
  const { data: groupData } = useGetAccountGroup()
  const textFieldCreateData = [
    {
      label: 'Mã sinh viên',
      type: 'text',
      name: 'schoolId',
      length: 100,
      required: true,
      disabled: actionName === 'Cập nhật',
    },
    {
      label: 'Họ tên',
      type: 'text',
      name: 'fullName',
      required: true,
      disabled: actionName === 'Cập nhật',
    },
    {
      label: 'Khoá',
      type: 'select',
      name: 'studentCourse',
      search: false,
      required: true,
      //Todo: When api created, update the options by a new useGetCourse hook
      options: courseOptions,
      disabled: actionName === 'Cập nhật',
    },
    {
      label: 'Nhóm người dùng',
      type: 'checkbox',
      name: 'groupUuids',
      required: true,
      options: (groupData?.groups ?? [])?.map((item) => ({
        value: item?.uuid,
        label: item?.name,
      })),
    },
    {
      label: 'Email',
      type: 'email',
      name: 'schoolEmail',
      span: 2,
      required: true,
      disabled: true,
    },
  ]

  return (
    <Modal
      onClose={closePopUp}
      className="h-auto w-[64vw] overflow-y-auto rounded-lg bg-gray-background px-12 py-8"
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
          }
        }}
        className="space-y-4"
      >
        <h1 className="pr-8 text-4xl font-bold text-black">{title}</h1>
        <div className="grid grid-cols-2 gap-4">
          {textFieldCreateData.map((field) => (
            <div
              key={field.name}
              className={field.span === 2 ? 'col-span-2' : ''}
            >
              <FormField
                {...field}
                register={register}
                errors={errors}
                control={control}
                placeholder={field?.placeholder}
                options={field?.options}
                size={field?.length}
              />
            </div>
          ))}
        </div>
        <div className="flex justify-end">
          <FormPageHeader
            title={title}
            actionName={actionName}
            closePopUp={closePopUp}
          />
        </div>
      </form>
    </Modal>
  )
}
